import Route from "@ember/routing/route"
import { inject as service } from "@ember/service"

export default class VersionRoute extends Route {
  @service("ember-store")
  store

  @service
  session

  model(params) {
    let cardStack = this.paramsFor("admin.card-stack")
    return this.store.find("document-version", `card-stack:${cardStack.id}:${params.versionNumber}`)
  }
}
